const { Limelight } = window;

const ThemeSections = require('@shopify/theme-sections');

// require('../../styles/sections/theme-footer.scss');

exports.default = () => {
  ThemeSections.register('theme-footer', {
    onLoad: function onLoad() {
      // Product wechat code
      const weChatPopup = new Limelight('#PopupWeChat', {
        bodyClass: 'active-popup'
      });

      // Popup submenus
      const footerDrawers = this.container.querySelectorAll('[data-trigger="drawer-menu"]');
      window.footerMenus = [];

      footerDrawers.forEach((drawer, index) => {
        window.footerMenus[index] = new Limelight('' + drawer.dataset.target, {
          beforeShowCallback: function beforeShowCallback(element, elements) {
            drawer.closest('.footer-nav-links').classList.add('invisible');
            element.element.querySelector('[data-scroll-state]').scrollTop = 0;
          },
          beforeHideCallback: function beforeHideCallback(element, elements) {
            drawer.closest('.footer-nav-links').classList.remove('invisible');
          }
        });
      });
    }
  });
};
